import { ThemeProvider } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';
import { useAuthStore } from 'src/stores/AuthStore/AuthStore';
import themeDark from 'src/utils/new_theme_dark';
import revampTheme from 'src/utils/revampTheme';

export const getDashboardTheme = (revampExperience: boolean) =>
  revampExperience ? revampTheme : themeDark;

/**
 * Chooses the shell-wide visual system only after authenticated organization
 * context is known. Keeping the legacy theme as the default makes sign-in,
 * onboarding, capability failures, and every non-rollout tenant unchanged.
 */
const DashboardThemeProvider = observer(({ children }: PropsWithChildren) => {
  const { isRevampExperience } = useAuthStore();
  const theme = getDashboardTheme(isRevampExperience());

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
});

export default DashboardThemeProvider;
